import React from 'react'
import Img from 'gatsby-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import Button from '../../atoms/Button/Button'
import './consulting-outstading.scss'

const ConsultingOutstading = props => {
	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, next) => (
				<p className='f-consulting-outstading-body-text'>{next}</p>
			),
			[BLOCKS.UL_LIST]: (node, next) => (
				<ul className='f-consulting-outstading-body-list'>{next}</ul>
			),
			[BLOCKS.EMBEDDED_ASSET]: node => (
				<img
					src={
						node.data.target.fields.file[process.env.LOCALE]
							? node.data.target.fields.file[process.env.LOCALE].url
							: node.data.target.fields.file['es-CO'].url
					}
					alt={
						node.data.target.fields.description[process.env.LOCALE]
							? node.data.target.fields.description[process.env.LOCALE]
							: node.data.target.fields.description['es-CO']
					}
					className='f-consulting-outstading-image'
				/>
			),
		},
	}


	return (
		<div className='f-consulting-outstading-container'>
			{props.ismobile ? (
				<div className='f-consulting-outstading'>
					<div className='f-consulting-outstading-body'>
						{documentToReactComponents(
							props.consultingOutstading.info.json,
							options
						)}
						<Button
							text={props.consultingOutstading.cta}
							type='button'
							classname='f-button f-button--primary'
							onClickAction={() => {
								window.location.href = props.consultingOutstading.ctaRedirection
							}}
						/>
					</div>
				</div>
			) : (
				<div className='f-consulting-outstading'>
					<div className='f-consulting-outstading-image-container'>
						<Img
							className='f-consulting-outstading-image'
							fluid={props.consultingOutstading.images[0].fluid}
							alt={props.consultingOutstading.images[0].description}
						/>
					</div>
					<div className='f-consulting-outstading-body'>
						{documentToReactComponents(
							props.consultingOutstading.info.json,
							options
						)}
						<Button
							text={props.consultingOutstading.cta}
							type='button'
							classname='f-button f-button--primary'
							onClickAction={() => {
								window.location.href = props.consultingOutstading.ctaRedirection
							}}
						/>
					</div>
				</div>
			)}
		</div>
	)
}

export default ConsultingOutstading
